import { lazy } from 'react';

const ComplaintsPage = lazy(() => import('../pages/Complaints.page'));

const ComplaintsRoutes = [
    {
        path: '/complaints',
        element: <ComplaintsPage />,
        layout: 'default',
        isAuthReq: true,
    },
];

export { ComplaintsRoutes };
